import { render } from "./CarFeeDirect.vue?vue&type=template&id=629ab146&scoped=true"
import script from "./CarFeeDirect.vue?vue&type=script&lang=js"
export * from "./CarFeeDirect.vue?vue&type=script&lang=js"

import "./CarFeeDirect.vue?vue&type=style&index=0&id=629ab146&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629ab146"]])

export default __exports__